export const NXGRetailInfoListVariants = {
  card: 'card',
  section: 'section'
} as const

export type NXGRetailInfoListVariant =
  (typeof NXGRetailInfoListVariants)[keyof typeof NXGRetailInfoListVariants]

export interface NXGRetailInfoListRow {
  key?: string
  label: string
  value: string | number | boolean
}
